module.exports = __webpack_public_path__ + "img/img_general3x3.43353c65.png";